var _rect, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "checkbox-big",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.001,
    height: 21,
    viewBox: "0 0 21.001 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_20982",
    "data-name": "Rechteck 20982",
    width: 21,
    height: 21,
    rx: 3,
    transform: "translate(0 0)",
    fill: "#3b3b39"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pfad_283892",
    "data-name": "Pfad 283892",
    transform: "translate(-125.301 -222.704)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_283893",
    "data-name": "Pfad 283893",
    d: "M134.1,238.438,129.665,234l1.272-1.273,3.164,3.164,7.19-7.189,1.272,1.273Z",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rechteck_20982-2",
    "data-name": "Rechteck 20982",
    d: "M143.614,224.072a2,2,0,0,1,2,2v15a2,2,0,0,1-2,2h-15a2,2,0,0,1-2-2v-15a2,2,0,0,1,2-2h15m0-1h-15a3,3,0,0,0-3,3v15a3,3,0,0,0,3,3h15a3,3,0,0,0,3-3v-15a3,3,0,0,0-3-3Z",
    transform: "translate(-125.613 -223.072)",
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxBig);
export default __webpack_public_path__ + "static/media/checkbox-big.f84d94b7248be1bde99b75e301cdaf69.svg";
export { ForwardRef as ReactComponent };